import { WEAPONS } from "./definitions.js";
import type { EquipmentKey } from "./arsenal.js";
import { systemParameters } from "./ship-systems.js";

export const EQUIPMENT_TIERS = [0, 1, 2] as const;
export type EquipmentTier = (typeof EQUIPMENT_TIERS)[number];
export interface EquipmentTiers {
  weapon: EquipmentTier;
  module: EquipmentTier;
  secondaryModule: EquipmentTier;
  passive: EquipmentTier;
}
export const BASE_EQUIPMENT_TIERS: Readonly<EquipmentTiers> = {
  weapon: 0,
  module: 0,
  secondaryModule: 0,
  passive: 0,
};
export function equipmentTierFactor(tier: EquipmentTier): number {
  return 1 + tier * 0.1;
}
export function equipmentPrimaryParameter(
  key: EquipmentKey,
  tier: EquipmentTier,
): {
  label: string;
  value: number;
  unit: string;
} {
  const factor = equipmentTierFactor(tier);
  if (key.kind === "system") return systemParameters(key.id, tier)[0];
  if (key.kind === "weapon")
    return {
      label: "Урон снаряда",
      value: WEAPONS[key.id].damage * factor,
      unit: "",
    };
  if (key.kind === "module") {
    switch (key.id) {
      case "volley":
        return {
          label: "Множитель урона оружия",
          value: 2.8 * factor,
          unit: "×",
        };
      case "mine":
        return { label: "Урон мины", value: 65 * factor, unit: "" };
      case "barrier":
        return {
          label: "Длительность барьера",
          value: 3.5 * factor,
          unit: "с",
        };
      case "repair":
        return { label: "Ремонт корпуса", value: 40 * factor, unit: "HP" };
      case "jammer":
        return { label: "Длительность помех", value: 4 * factor, unit: "с" };
      case "interceptor":
        return { label: "Радиус перехвата", value: 320 * factor, unit: "" };
      case "repair-field":
        return { label: "Ремонт в секунду", value: 4 * factor, unit: "HP/с" };
      case "scan":
        return { label: "Радиус сканирования", value: 900 * factor, unit: "" };
    }
  }
  switch (key.id) {
    case "targeting":
      return { label: "Бонус дальности", value: 15 * factor, unit: "%" };
    case "capacitor":
      return { label: "Дополнительная энергия", value: 25 * factor, unit: "" };
    case "repair-drone":
      return { label: "Ремонт вне боя", value: factor, unit: "HP/с" };
    case "thrusters":
      return { label: "Бонус скорости форсажа", value: 15 * factor, unit: "%" };
  }
}

export function equipmentParameters(key: EquipmentKey, tier: EquipmentTier) {
  return key.kind === "system" ? systemParameters(key.id, tier) : [equipmentPrimaryParameter(key, tier)];
}
